import uniq from "lodash/uniq";
import { create } from "zustand";
import { immer } from "zustand/middleware/immer";
import { useShallow } from "zustand/react/shallow";

import { ChatState, ChatStore } from "./chat_store_types";

const INITIAL_STATE: ChatState = {
  ids: [],
  expandedId: null,
  minimizedIds: ["list"],
  selectedId: null
};

export const useChatStore = create<ChatStore>()(
  immer((set) => ({
    ...INITIAL_STATE,
    actions: {
      renderChat: (id, options = {}) =>
        set((state) => {
          const alreadyRendered = state.ids.includes(id);

          if (options.expanded) {
            state.expandedId = id;
          }
          if (options.minimized) {
            if (!alreadyRendered) {
              state.minimizedIds.push(id);
            }
          } else if (alreadyRendered) {
            state.minimizedIds = state.minimizedIds.filter((candidate) => candidate !== id);
          }

          state.ids = uniq([...state.ids, id]);
          state.selectedId = id;
        }),

      unrenderChat: (id) =>
        set((state) => {
          state.ids = state.ids.filter((candidate) => candidate !== id);
          state.selectedId = null;
          state.expandedId = state.expandedId === id ? null : state.expandedId;
          state.minimizedIds = state.minimizedIds.filter((candidate) => candidate !== id);
        }),

      minimizeChat: (id) =>
        set((state) => {
          state.minimizedIds.push(id);
        }),

      unMinimizeChat: (id) =>
        set((state) => {
          state.minimizedIds = state.minimizedIds.filter((candidate) => candidate !== id);
        }),

      selectChat: (id) =>
        set((state) => {
          state.selectedId = id;
        }),

      expandChat: (id, value) =>
        set((state) => {
          state.expandedId = value ? id : null;
        }),

      reset: () =>
        set((state) => {
          Object.assign(state, INITIAL_STATE);
        })
    }
  }))
);

export const useChatStoreActions = () => useChatStore(useShallow((state) => state.actions));
